import React from 'react';
import { Link } from 'react-router-dom';
import { BrainIcon, ArrowRightIcon } from 'lucide-react';
export function PlatformStudioPage() {
  return <div className="w-full" data-id="element-7775">
      {/* Hero */}
      <section className="bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 text-white py-24" data-id="element-7776">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7777">
          <div className="max-w-3xl" data-id="element-7778">
            <h1 className="text-5xl font-bold mb-6" data-id="element-7779">GTM Studio</h1>
            <p className="text-xl text-purple-100 mb-8" data-id="element-7780">
              Design and build GTM plays visually with our intuitive studio
              interface. Create segments, design workflows, and launch campaigns
              in minutes.
            </p>
            <div className="flex items-center gap-4" data-id="element-7781">
              <Link to="/gtm-studio/workspace" className="px-6 py-3 bg-white text-purple-900 rounded-lg hover:bg-purple-50 font-medium" data-id="element-7782">
                Open Studio
              </Link>
              <Link to="/website/contact" className="px-6 py-3 border border-white text-white rounded-lg hover:bg-white/10 font-medium" data-id="element-7783">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Features */}
      <section className="py-20 bg-white" data-id="element-7784">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7785">
          <div className="text-center mb-16" data-id="element-7786">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-7787">
              Studio Features
            </h2>
            <p className="text-lg text-gray-600 mt-4" data-id="element-7788">
              Everything you need to design effective GTM plays
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7789">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7790">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7791">
                <BrainIcon className="w-6 h-6 text-purple-600" data-id="element-7792" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7793">Visual Builder</h3>
              <p className="text-gray-600" data-id="element-7794">
                Drag-and-drop interface to design complex GTM plays without
                coding.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7795">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7796">
                <BrainIcon className="w-6 h-6 text-purple-600" data-id="element-7797" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7798">AI Templates</h3>
              <p className="text-gray-600" data-id="element-7799">
                Start with AI-powered templates for common GTM scenarios.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7800">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7801">
                <BrainIcon className="w-6 h-6 text-purple-600" data-id="element-7802" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7803">Segmentation</h3>
              <p className="text-gray-600" data-id="element-7804">
                Create precise audience segments with our powerful targeting
                tools.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 bg-purple-50" data-id="element-7805">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-7806">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-7807">
            Ready to start building?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-7808">
            Get started with Studio today and transform your GTM strategy
          </p>
          <Link to="/gtm-studio/workspace" className="px-8 py-4 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium inline-flex items-center gap-2" data-id="element-7809">
            Open Studio
            <ArrowRightIcon className="w-5 h-5" data-id="element-7810" />
          </Link>
        </div>
      </section>
    </div>;
}